import { render, staticRenderFns } from "./usernopwd.vue?vue&type=template&id=1f2f9ee4"
import script from "./usernopwd.vue?vue&type=script&lang=js"
export * from "./usernopwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports